// toolkitService.js
import axios from "axios";

const TOOLKIT_BASE_URL = 'https://toolkit.opt4solution.site';

//Harshada Bhavsar - 14/10/2025
//Get Captcha
export const getCaptcha = async (hexColor) =>{
    try{
        const response = await axios.get(`${TOOLKIT_BASE_URL}/api/Captcha/GetCaptcha?hexColor=${encodeURIComponent(hexColor)}`);
        return response.data;
    }catch(error){
        console.log("Error fetching captcha:", error);
        throw error;
    }
}